import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Snackbar } from '@material-ui/core'

import { RootState } from 'reducers/rootState.types'
import i18n from '../i18n'
import './App.scss'

const GlobalMessage = () => {
    const [isOpen, setIsOpen] = useState(false)
    const { code, message, type } = useSelector((state: RootState) => {
        return state.message
    })

    const hasDetails = code || message

    useEffect(() => {
        if (hasDetails) {
            setIsOpen(true)
        }
    }, [hasDetails])

    const handleClose = () => {
        setIsOpen(false)
    }

    const mapCodeToMessage = (code: number) => {
        switch (code) {
            case 400:
                return 'Bad Request: Request sent invalid syntax.'
            case 401:
                return 'Unauthorized: Sorry, you have not been authenticated.'
            case 403:
                return 'Forbidden: You do not have permission.'
            case 404:
                return "Not Found: Uh oh! We couldn't find what you are looking for!"
            case 500:
                return 'Internal Server Error: Cannot process the request.'
            case 502:
                return 'Bad Gateway: Not receiving a valid response from the servers.'
            case 503:
                return 'Service Unavailable: Server is overloaded or under maintenance.'
            case 504:
                return 'Gateway Timeout: Not receiving a response from the servers.'
            default:
                return 'Something went wrong! :('
        }
    }

    const getMessage = (code: number, message: string) => {
        if (code === 429 && message) {
            const time = message.match(/[0-9]+/)

            if (time) {
                const timeout = Math.ceil(Number(time) / 60)

                return i18n.t('AUTH.MFA.MESSAGES.TOO_MANY_REQUESTS', { timeout })
            }
        }

        if (message) {
            return message
        }

        return mapCodeToMessage(code)
    }

    if (hasDetails) {
        return (
            <div className={`${type}-message`}>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={isOpen}
                    onClose={handleClose}
                    autoHideDuration={5000}
                    message={<span>{getMessage(code, message)}</span>}
                />
            </div>
        )
    }

    return null
}

export default GlobalMessage
